function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.3335 18.3333V3.33329C3.3335 3.20392 3.36362 3.07633 3.42147 2.96061C3.47933 2.8449 3.56333 2.74425 3.66683 2.66663C4.53231 2.01752 5.58498 1.66663 6.66683 1.66663C9.16683 1.66663 10.8335 3.33329 12.7777 3.33329C13.8888 3.33329 14.7407 3.11107 15.3335 2.66663C15.4573 2.57377 15.6045 2.51722 15.7587 2.50333C15.9128 2.48943 16.0678 2.51873 16.2062 2.58794C16.3446 2.65715 16.461 2.76354 16.5424 2.89518C16.6237 3.02683 16.6668 3.17853 16.6668 3.33329V11.6666C16.6668 11.796 16.6367 11.9236 16.5789 12.0393C16.521 12.155 16.437 12.2557 16.3335 12.3333C15.468 12.9824 14.4153 13.3333 13.3335 13.3333C10.8335 13.3333 9.16683 11.6666 6.66683 11.6666C5.43693 11.6667 4.25018 12.12 3.3335 12.94",
  stroke: "currentColor",
  strokeWidth: 1.45833,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.07329b72.svg";
export { ForwardRef as ReactComponent };